module.exports = __webpack_public_path__ + "static/media/ic_table_up_caret.201a03b2.svg";